import { gql } from '@apollo/client';

export const scenesProgressQuery = gql`
  query ScenesProgress(
    $input: PlayableScenesInput!
    $progressInput: SceneProgressInput!
  ) {
    playableScenes(input: $input) {
      id
      name
      image
      progress(input: $progressInput) {
        gameCount
        alreadyFinished
        tournament
      }
    }
  }
`;

export const currentScenesQuery = gql`
  query CurrentScenes(
    $gameDifficulty: GameDifficulty!
    $progressInput: SceneProgressInput!
  ) {
    currentScenes(gameDifficulty: $gameDifficulty) {
      id
      name
      image
      statuses
      progress(input: $progressInput) {
        gameCount
        alreadyFinished
        tournament
        training
      }
    }
  }
`;

export const companyTraining = gql`
  query CompanyTraining(
    $input: CompanyTrainingInput!
  ) {
    companyTraining(input: $input) {
      id
      name
      scenes {
        id
        name
      }
    }
  }
`;

export const createCpuGameMutation = gql`
  mutation CreateCpuGame($input: CreateCpuGameInput!) {
    createCpuGame(input: $input) {
      id
    }
  }
`;

export const setGameDifficultyMutation = gql`
  mutation SetGameDifficulty($input: SetGameDifficultyInput!) {
    setGameDifficulty(input: $input) {
      id
      gameDifficulty
    }
  }
`;

export const gamePreviewIdQuery = gql`
  query gamePreviewId($input: GamePreviewIdInput!) {
    gamePreviewId(input: $input)
  }
`;

export const tournamentLeaderboardQuery = gql`
  query TournamentLeaderboardQuery {
    tournamentsLeaderboard {
      leaderboards {
        tournamentId
        tournamentName
        playerCount
        playerStanding
        wins
        winsBySecretTarget
        losses
        lossesBySecretTarget
        standings {
          name
          email
          standing
        }
      }
    }
  }
`;

export const profileStatsQuery = gql`
  query ProfileStatsQuery($leaderboardType: LeaderboardType!, $trainingId: ID) {
    me {
      id
      gameStatistics(
        leaderboardType: $leaderboardType
        trainingId: $trainingId
      ) {
        wins
        winsBySecretTarget
        losses
        lossesBySecretTarget
        standing
        playersCount
      }
    }
  }
`;
